<template>
    <div class="notifications-index">
        <span class="dropdown-item" v-if="!notifications.length">
            Aucune notifications.
        </span>
        <div class="pagination">
            <div class="page-subtitle">{{ total_item }} notifications</div>
            <el-pagination @current-change="page => paginate(page, 'top')" :current-page.sync="params.page" :page-size="params.limit" :pager-count="11" layout="sizes, prev, pager, next" :page-sizes="page_sizes" @size-change="handleSizeChange" :total="total_item"></el-pagination>
        </div>
        <el-table style="width: 100%" ref="multipleTable" :data="notifications"  stripe @sort-change="changeSort" v-loading="loading">
            <el-table-column type="selection" width="55"></el-table-column>
            <el-table-column type="expand">
                <template slot-scope="scope">
                    <template v-if="scope.row.data.details && scope.row.data.details.reason" >
                        {{ scope.row.data.details.product.shop_id }} - {{ scope.row.data.details.product.name }} <span v-if="scope.row.data.details.reason == 'delete_forbidden_on_active_product'"> - <a href="#" @click.prevent="restoreProduct( scope.row.data.details.product.id, scope.row )" class="text-danger">Restaurer le produit</a></span>
                    </template>
                    <template v-if="scope.row.data.details && scope.row.data.details.exception">
                        <span class="text-danger">{{ scope.row.data.details.exception }}</span>
                    </template>
                </template>
            </el-table-column>
            <el-table-column label="Titre" sortable="custom">
                <template slot-scope="scope">
                    {{ scope.row.title }}
                </template>
            </el-table-column>
            <el-table-column label="Détail" sortable="custom">
                <template slot-scope="scope">
                    {{ scope.row.desc }}
                </template>
            </el-table-column>
            <el-table-column prop="elapseTime" label="Date" sortable="custom"></el-table-column>
            <el-table-column label="Actions" fixed="right">
                <template slot-scope="scope">
                    <a href="#" class="custom-btn" @click.prevent="read(scope.row)" title="Marquer comme lu"><i class="fe fe-check"></i></a>
                    <a :href="scope.row.link" class="custom-btn" target="_blank" title="Télécharger"><i v-if="scope.row.link" class="fe fe-download"></i></a>
                    <a v-if="scope.row.data.details && scope.row.data.details.jobId && scope.row.type == 'App\Notifications\ErrorJob' " href="#" @click.prevent="reloadJob(scope.row, scope.row.data.details.jobId)" class="custom-btn" title="Relancer"><i class="fe fe-refresh-cw"></i></a>
                </template>
            </el-table-column>
        </el-table>
        <div class="pagination">
            <el-pagination :page-size="params.limit" layout="sizes, prev, pager, next" :pager-count="11" :total="total_item" @current-change="page => paginate(page, 'bottom')" :page-sizes="page_sizes" @size-change="handleSizeChange" :current-page="params.page">
            </el-pagination>
        </div>

    </div>
</template>
<script>
import queryString from 'query-string';
import Notifications from '../../notifications'

export default {
    data() {
        return {
            multipleSelection: [],
            page_sizes: [10, 20, 30, 40, 50, 100, 200],
            params: {
                page: 1,
                orderBy: 'created_at',
                order: 'DESC',
                limit: 10
            },
            defaultParams: {
                page: 1,
                orderBy: 'created_at',
                order: 'DESC',
                limit: 10
            },
            filters: {},
            loading: false,
        }
    },
    computed: {
        total_item() {
            return this.$store.getters['notifications/totalItems'];
        },
        notifications() {
            return this.$store.getters['notifications/items'];
        },
        currentUrl() {
            return (
                window.location.protocol +
                '//' +
                window.location.host +
                window.location.pathname
            );
        },
    },
    watch: {
        params: {
            handler(newV, oldV) {
                var newUrl =
                    this.currentUrl + '?' + queryString.stringify(newV);
                window.history.pushState({ path: newUrl }, '', newUrl);
            },
            deep: true
        }
    },
    mounted() {
        Notifications.desactivate();
        this.fetch();

    },
    methods: {
        fetch(params) {
            if (!params) {
                params = {};
            }
            params = { ...params, ...this.params };
            this.loading = true;
            return this.$store.dispatch('notifications/fetch', params).then(() => {
                this.loading = false;
            });
        },
        goToPage(p) {
            this.params.page = p;
            this.fetch();
        },

        changeSort(s) {
            this.params.orderBy = s.prop;
            this.params.order = s.order == 'ascending' ? 'asc' : 'desc';

            this.fetch();
        },

        handleSizeChange(val) {
            this.params.limit = val;
            this.fetch();
        },
        paginate(page, paginator) {
            this.params.page = page;
            this.loader = true;
            this.fetch()
                .then(r => {
                    if (paginator == 'bottom') {
                        var element = document.querySelector(
                            '.notifications-index'
                        );
                        element.scrollIntoView();
                    }
                })
                .catch(() => {})
                .then(() => {
                    this.loader = false;
                });
        },
        read(noty) {
            this.$store.dispatch('notifications/read', noty);
        },
        readAll(noty) {
            this.$store.dispatch('notifications/readAll');
        },
        reloadJob(noty, jobId) {
            axios.post('/jobs/' + jobId + '/reload').then(() => {
                this.read(noty);
            });
        },
        restoreProduct(productId, noty)
        {
            axios.post('products/restore/', {products: [productId]}).then(() => {
                this.read(noty);
            });
        }
    }
};
</script>
<style lang="scss">
.notifications-list {
    .custom-btn {
        width: 100%;
        display: block;
        text-align: right;
        font-size: 17px;
    }
    .border-right {
        border-right: 1px solid #6c757d;
    }
}
</style>
